import { useRef } from "react";

import ConfirmationPopover from "@/appComponents/Blocks/Composites/ConfirmationPopover/ConfirmationPopover";
import { appstr } from "@coreapp/utils/appstr";
import { Text, Tooltip } from "@theorgchartdev/storybook";

export const DeletePlanPopover = ({ handleDelete, dataTestId, onPopoverOpen, onPopoverClose }) => {
  const openCtrlRef = useRef(null);

  const handleClick = e => {
    e.stopPropagation();
  };

  const handleKeyDown = e => {
    e.stopPropagation();
  };

  return (
    <div onClick={handleClick} onKeyDown={handleKeyDown}>
      <Tooltip message={appstr("Delete plan")} referenceOpenCtrlRef={openCtrlRef}>
        <ConfirmationPopover
          openCtrlRef={openCtrlRef}
          onSubmit={handleDelete}
          icon={"trash-can"}
          iconOnly
          iconProps={{
            size: "small"
          }}
          color="error"
          otherHeaderProps={{ title: appstr("Delete plan") + "?" }}
          confirmLabel={appstr("Delete")}
          triggerTestId={dataTestId}
          popoverProps={{
            onOpen: onPopoverOpen,
            onClose: onPopoverClose
          }}
          dataTestPrefix={dataTestId}
        >
          <Text>{appstr("Delete plan message")}</Text>
        </ConfirmationPopover>
      </Tooltip>
    </div>
  );
};
